<cmv-modal-base *ngIf="isModalVisible">
	<section class="get-debit-card">
		<button class="get-debit-card__btn-close" (click)="onCloseModal()">
			<i class="bi bi-x"></i>
		</button>
		<h1 class="get-debit-card__title">¡Adquiere tu tarjeta adicional!</h1>
		<div class="get-debit-card__content">
			<img src="./assets/images/tdc/vertical-debit-card.svg" alt="" />
			<p>
				Al obtener un <b>crédito</b> con <b>nosotros</b>, te damos una
				<b> tarjeta de débito VISA </b> con la que puedes pagar y disponer en
				miles de <b>ATM’s</b> en todo el mundo. Administra esta tarjeta desde
				nuestra app <b>CMV+</b> por solo <b>$35. (+iva)</b> mensuales.
			</p>
		</div>
		<section class="get-debit-card__action-btns">
			<button class="get-debit-card__reject-btn" (click)="onRejectDebitCard()">
				No la quiero
			</button>
			<button class="get-debit-card__accept-btn" (click)="onAcceptDebitCard()">
				La quiero
			</button>
		</section>
	</section>
</cmv-modal-base>
